import * as React from 'react'
import TextareaAutosize, {
  TextareaAutosizeProps,
} from 'react-textarea-autosize'

import { cn } from '@/shared/lib/utils'

export type TextareaProps = TextareaAutosizeProps & {
  /**
   * The minimum number of rows to display for the textarea.
   * Defaults to 3 rows which roughly corresponds to the previous 80px min-height.
   */
  minRows?: number
  /**
   * Optional maximum number of rows before the textarea stops growing.
   */
  maxRows?: number
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, minRows = 3, maxRows, ...props }, ref) => {
    return (
      <TextareaAutosize
        className={cn(
          'flex w-full rounded-md border bg-paper px-3 py-2 text-sm placeholder:text-mydra-gray disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        minRows={minRows}
        maxRows={maxRows}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }
